var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 102,
    viewBox: "0 0 120 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5303 76.5986H42.663V95.5051H76.5303V76.5986Z",
    fill: "#27869F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3299 97.028H30.8642C28.1181 97.028 25.8922 99.2539 25.8922 102H93.3015C93.3015 99.2543 91.0756 97.028 88.3295 97.028H88.3299Z",
    fill: "#27869F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5303 76.5986H42.663V83.5035H76.5303V76.5986Z",
    fill: "#27869F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90043 0H114.293C116.998 0 119.194 2.19572 119.194 4.90044V74.4567C119.194 77.1614 116.998 79.3571 114.293 79.3571H4.90043C2.19572 79.3571 0 77.1614 0 74.4567V4.90044C0 2.19572 2.19572 0 4.90043 0Z",
    fill: "#27869F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.584 6.40878H5.60971V72.9487H113.584V6.40878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.18c18ad7961cc2658228df3a8d20f2c5.svg";
export { ForwardRef as ReactComponent };